<div class="grid-container" [ngClass]="{'overflow-auto': rowData.length}" style="position: relative;">
  <table class="sgrid-data">
    <tr>
      <th *ngFor="let h of columnDefs" [ngClass]="{'action-column': h.isAction}">{{h.headerName | translate}}</th>
    </tr>
    <tr *ngFor="let row of rowData">
      <td *ngFor="let h of columnDefs" [ngClass]="{'action-column': h.isAction}">
        <ng-container *ngIf="!h.isAction">
          {{h.valueFormatter? h.valueFormatter(row): row[h.field]}}
        </ng-container>
        <ng-container *ngIf="h.isAction">
          <button 
            class="button button--small action-button" 
            (click)="triggerAutomateTool(row)"
            type="button"
            [disabled]="row.file_type !== 'C' || row.upload_status !== 'Completed' || row.automationToolStatus?.automationStatus === 'COMPLETED'" >
            {{  'sfu_trigger_automation_tool' | translate }}
          </button>
        </ng-container>
      </td>
    </tr>
  </table>
  <div class="msg-container">
    <span [ngClass]="{'error-msg': errorMsg}">{{getMessage() | translate}}</span>
  </div>
  <div *ngIf="isLoading" class="table-loader-overlay">
    <div class="sgrid-loader"></div>
  </div>
</div>